<template>
  <div
    class="card-body col-8 pt-0 p-3 mx-auto border-radius-lg mb-4"
    style="background-color: rgb(245, 245, 245)"
  >
    <div
      :id="`lineAccordion-${lineId}`"
      class="accordion"
    >
      <div class="accordion-item">
        <h2
          :id="`heading-${lineId}`"
          class="accordion-header"
        >
          <button
            class="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            :data-bs-target="`#collapse-${lineId}`"
            aria-expanded="true"
            :aria-controls="`collapse-${lineId}`"
            style="background-color: rgb(245, 245, 245)"
          >
            <div class="col p-2">
              <span class="text-lg"> Line Name </span>
              <div class="d-flex align-items-center">
              <h6 class="text-2xl mb-0">{{ lineName }}</h6>
              <i
                class="fa fa-chevron-down ms-2"
                aria-hidden="true"
                style="font-size: 1.3rem;"
              ></i>
              <i
                class="fa fa-chevron-up ms-2"
                aria-hidden="true"
                style="font-size: 1.3rem;"
              ></i>
              </div>
            </div>
            <div class="d-flex flex-column flex-md-row align-items-center ms-auto gap-4">
              <div class="text-end">
                <span class="text-xs"> Last used </span>
                <div class="my-auto">
                  <p style="font-size: 0.8rem">
                    <b>{{ lineUsedAt }}</b>
                  </p>
                </div>
              </div>
            </div>
          </button>
        </h2>
        <div
          :id="`collapse-${lineId}`"
          class="accordion-collapse collapse show"
          :aria-labelledby="`heading-${lineId}`"
          :data-bs-parent="`#lineAccordion-${lineId}`"
        >
          <div class="accordion-body p-0">
            <ul class="list-group">
              <send-recipes-hopper-card
                v-for="[hopper_id, hopper_data] in Object.entries(hopperDataByHopperId)"
                :key="hopper_id"
                :hopper-id="hopper_id"
                :hopper-name="hopper_data.hopper_name"
                :plc-status="hopper_data.plc_status"
                :recipe-data-by-recipe-id="hopper_data.recipe_data_by_recipe_id"
                :gun-names-by-gun-id="gunNamesByGunId"
                @reload-data="$emit('reload-data')"
              />
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import SendRecipesHopperCard from "@/views/applications/steelcase/components/SendRecipesHopperCard.vue";

export default {
  name: "SendRecipesLineCard",
  components: {
    SendRecipesHopperCard,
  },
  props: {
    lineId: {
      type: String,
      default: "",
    },
    lineName: {
      type: String,
      default: "",
    },
    lineUsedAt: {
      type: String,
      default: "",
    },
    gunNamesByGunId: {
      type: Object,
      default: () => ({}),
    },
    hopperDataByHopperId: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: [
    "reload-data",
  ],
  data() {
    return {};
  },
  methods: {},
};
</script>
